import clsx from "clsx";
import type { ComponentProps } from "react";

import type { ColorIconType } from "@shared/content-types/types/common";
import { BrandIcon } from "@shared/ui/brand-icon";
import { Body, Heading } from "@shared/ui/typography";
import { formatPhoneForLink } from "@shared/utils/phone-formatter";

import s from "./contact-card.module.scss";

export type ContactCardProps = ComponentProps<"div"> & {
  className?: string;
  phone: string;
  title: string;
  icon?: ColorIconType;
};

export const ContactCard = (props: ContactCardProps) => {
  const { className, phone, title, icon } = props;

  return (
    <div className={clsx(s.root, className)}>
      <div className={s.top}>
        {title != null && title !== "" && (
          <Body size="primary" weight="semiBold" className={s.title}>
            {title}
          </Body>
        )}
        {icon?.icon?.name && (
          <BrandIcon
            className={s.icon}
            name={icon.icon.name}
            fillColor={icon?.fillColor ?? "violet"}
            color={icon?.strokeColor ?? "white"}
          />
        )}
      </div>
      <div className={s.content}>
        {phone != null && phone !== "" && (
          <Heading
            level={5}
            tag="a"
            href={`tel:${formatPhoneForLink(phone)}`}
            className={clsx("global-link")}
          >
            {phone}
          </Heading>
        )}
      </div>
    </div>
  );
};

ContactCard.displayName = "ContactCard";
